import { canv } from "@/canv/global";
import { MakeRequest } from "@/canv/utils";
import { Button } from "@/shared/ui/Button";

type Props = {
    className?: string;
};

export const ShareButton = ({ className }: Props) => {
    const handleShareButtonClick = () => {
        // TODO: переделать shareWindow на реакт
        canv.appInterface.shareWindow.open({
            mode: "board",
            token: canv.getInitDataProp("userToken"),
            accessSelector: canv.appInterface.accessMenu.open.bind(canv.appInterface.accessMenu),
            host: canv.host,
            HTTPRequest: MakeRequest,
            stateChange: () => {},
            notificator: canv.appInterface.infoWindow.open.bind(canv.appInterface.infoWindow),
            searchInputState: (state) => {
                canv.appInterface.inputFocused = state;
            },

            boardUID: canv.getInitDataProp("boardUID"),
            onlyRead: canv.getInitDataProp("onlyRead"),
        });
    };

    return (
        <Button onClick={handleShareButtonClick} size="m" className={className}>
            Поделиться
        </Button>
    );
};
